import { AvatarEntity } from "@cryptors/api-client";
import { Box, TextField } from "@mui/material";
import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Controller } from "react-hook-form";

import UploadButton from "@/components/forms/UploadButton";
import { removeQueryParams } from "@/utils/parseUrl";
import { upload } from "@/utils/upload";

interface AvatarFormValues {
  id?: number;
  image: { url: string };
}

export const AvatarEdit: React.FC<IResourceComponentsProps> = () => {
  const {
    refineCore: { formLoading, onFinish },
    register,
    formState: { errors, isValid, isDirty },
    setError,
    control,
    handleSubmit,
  } = useForm<AvatarEntity, HttpError, AvatarFormValues>();

  const onFinishHandler = (data: AvatarFormValues) => {
    onFinish({
      image: { url: removeQueryParams(data.image.url) },
    });
  };

  return (
    <Edit
      isLoading={formLoading}
      saveButtonProps={{
        onClick: handleSubmit(onFinishHandler),
        disabled: !isDirty || !isValid,
      }}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("id", {
            required: "Ce champ est requis",
            valueAsNumber: true,
          })}
          defaultValue={null}
          error={!!errors.id}
          helperText={errors.id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Id"
          name="id"
          disabled
        />
        <Controller
          control={control}
          name="image.url"
          defaultValue=""
          rules={{ required: "Ce champ est requis" }}
          render={({ field, fieldState }) => (
            <UploadButton
              inputSrc={field.value}
              label="Image"
              onError={() =>
                setError("image.url", {
                  message: "L'upload a échoué. Veuillez réessayer",
                })
              }
              errorMessage={fieldState.error?.message}
              onChange={async (event) => {
                const url = await upload(event, "avatars");
                field.onChange(url);
              }}
            />
          )}
        />
      </Box>
    </Edit>
  );
};
